module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Tidsbegrænset undervisningstillæg")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content text-dark"
  }, [_c('p', {
    staticClass: "tuv__intro"
  }, [_vm._v("\n        Beregn UV-tillæg for en tidsbegrænset ansættelse ud fra skoledage og UV-tid, og send et fast tillæg\n        for perioden direkte til " + _vm._s(_vm.salaryTargetLabel) + " på baggrund af beregningen.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "do-form-row"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Vælg ansat")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userId),
      expression: "userId"
    }],
    staticClass: "height-34 do-select width-100",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onUserChange]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Vælg ansat")]), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('option', {
      key: user.id,
      domProps: {
        "value": user.id
      }
    }, [_vm._v(_vm._s(user.name))])
  })], 2)]), _vm._v(" "), (_vm.userId) ? _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Vælg ansættelse")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentId),
      expression: "employmentId"
    }],
    staticClass: "height-34 do-select width-100",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onEmploymentChange]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _vm._l((_vm.userEmployments), function(emp) {
    return _c('option', {
      key: emp.id,
      domProps: {
        "value": emp.id
      }
    }, [_vm._v(_vm._s(emp.label))])
  })], 2), _vm._v(" "), (_vm.userEmployments.length === 0) ? _c('p', {
    staticClass: "tuv__hint"
  }, [_vm._v("\n            Ingen " + _vm._s(_vm.salaryTargetLabel) + "-ansættelse med stillingskategori fundet for personen.\n          ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.userId) ? [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "isLoaderModal": true
    }
  }) : [_c('div', {
    staticClass: "tuv__facts"
  }, [_c('div', {
    staticClass: "tuv__fact"
  }, [_c('span', {
    staticClass: "tuv__fact-label"
  }, [_vm._v("Ansættelsesgrad")]), _vm._v(" "), _c('span', {
    staticClass: "tuv__fact-value"
  }, [_vm._v(_vm._s(_vm.ansaettelsesgradPercent != null ? _vm.formatPercent(_vm.ansaettelsesgradPercent) : '—'))])]), _vm._v(" "), _c('div', {
    staticClass: "tuv__fact"
  }, [_c('span', {
    staticClass: "tuv__fact-label"
  }, [_vm._v("Periode (årsnorm)")]), _vm._v(" "), _c('span', {
    staticClass: "tuv__fact-value"
  }, [_vm._v(_vm._s(_vm.periodLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "tuv__fact"
  }, [_c('span', {
    staticClass: "tuv__fact-label"
  }, [_vm._v("Bruttotid")]), _vm._v(" "), _c('span', {
    staticClass: "tuv__fact-value"
  }, [_vm._v(_vm._s(_vm.yearNormHours != null ? _vm.formatDecimal(_vm.yearNormHours) : '—'))])])]), _vm._v(" "), _c('div', {
    staticClass: "do-form-row"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Lønkode")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salaryCodeId),
      expression: "salaryCodeId"
    }],
    staticClass: "height-34 do-select width-100",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.salaryCodeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _vm._l((_vm.selectableSalaryCodes), function(salaryCode) {
    return _c('option', {
      key: salaryCode.id,
      domProps: {
        "value": salaryCode.id
      }
    }, [_vm._v("\n                  " + _vm._s(salaryCode.vSupplementTitle || salaryCode.code) + "\n                ")])
  })], 2)]), _vm._v(" "), (_vm.salarySystem !== 'SD') ? _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Omkostningssted")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.costCenterId),
      expression: "costCenterId"
    }],
    staticClass: "height-34 do-select width-100",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.costCenterId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _vm._l((_vm.costCenters), function(costCenter) {
    return _c('option', {
      key: costCenter.id,
      domProps: {
        "value": costCenter.id
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.costCenterLabel(costCenter)) + "\n                ")])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "do-form-row"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Skoledage i skoleåret")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolDaysInYear),
      expression: "schoolDaysInYear"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "number",
      "min": "0",
      "inputmode": "numeric",
      "placeholder": "fx 200"
    },
    domProps: {
      "value": (_vm.schoolDaysInYear)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.schoolDaysInYear = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Skoledage i periode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolDaysInPeriod),
      expression: "schoolDaysInPeriod"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "number",
      "min": "0",
      "inputmode": "numeric",
      "placeholder": "fx 46"
    },
    domProps: {
      "value": (_vm.schoolDaysInPeriod)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.schoolDaysInPeriod = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("UV-grænse")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graense),
      expression: "graense"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "inputmode": "decimal",
      "placeholder": "750"
    },
    domProps: {
      "value": (_vm.graense)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.graense = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Justeret timetal")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustedHours),
      expression: "adjustedHours"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "inputmode": "decimal",
      "placeholder": "Total UV-tid for perioden"
    },
    domProps: {
      "value": (_vm.adjustedHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.adjustedHours = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tuv__hint"
  }, [_vm._v("\n              Som standard tæller "), _c('strong', [_vm._v("alt tildelt")]), _vm._v(" UV-tid med. Hvis kun det skemalagte for perioden skal\n              tælle med, så ret timetallet til det.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "tuv__scheduled"
  }, [_c('span', [_vm._v("\n                Skemalagt undervisning i perioden:\n                "), (!_vm.isLoadingScheduled) ? _c('strong', [_vm._v(_vm._s(_vm.scheduledInPeriod != null ? _vm.formatDecimal(_vm.scheduledInPeriod) + ' timer' : 'ukendt'))]) : _c('em', [_vm._v("henter…")])]), _vm._v(" "), (!_vm.isLoadingScheduled && _vm.scheduledInPeriod != null) ? _c('button', {
    staticClass: "tuv__use-scheduled",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.useScheduled
    }
  }, [_vm._v("\n                Brug skemalagt\n              ")]) : _vm._e()])]), _vm._v(" "), (_vm.isCalcValid) ? _c('div', {
    staticClass: "tuv__result"
  }, [_c('div', {
    staticClass: "tuv__result-steps"
  }, [_c('div', {
    staticClass: "tuv__result-row"
  }, [_c('span', [_vm._v("UV-timer omregnet til fuld tid")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDecimal(_vm.uvOmregnetFuldtid)))])]), _vm._v(" "), _c('div', {
    staticClass: "tuv__result-row"
  }, [_c('span', [_vm._v("Overskud over grænse (fuld tid)")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDecimal(_vm.surplusFuldtid)))])])]), _vm._v(" "), _c('div', {
    staticClass: "tuv__result-total"
  }, [_c('span', [_vm._v("UV-tillæg der udbetales i perioden")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatDecimal(_vm.resultUnits)) + " timer")])]), _vm._v(" "), (_vm.resultUnits > 0) ? _c('div', {
    staticClass: "tuv__result-row tuv__result-row--sub"
  }, [_c('span', [_vm._v("Sendes som fast tillæg til " + _vm._s(_vm.salaryTargetLabel))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDecimal(_vm.unitsPerInstallment)) + " enh./md · " + _vm._s(_vm.installments) + " " + _vm._s(_vm.installments === 1 ? 'måned' : 'måneder'))])]) : _vm._e(), _vm._v(" "), (_vm.resultUnits <= 0) ? _c('p', {
    staticClass: "tuv__result-note"
  }, [_vm._v("\n              UV-tiden er under grænsen i perioden – der er ingen UV-tid at oprette tillæg for.\n            ")]) : _vm._e()]) : _vm._e()]] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', {
    staticClass: "d-modal__buttons__left"
  }), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons__right"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSaving
    },
    attrs: {
      "disabled": !_vm.isValid || _vm.isSaving || _vm.isLoading
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("\n          " + _vm._s(_vm.submitButtonLabel) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e417e46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supplements/TidsbegraensetUvModal.vue
// module id = 1835
// module chunks = 1